<kiwi-competitive-intelligence
    [barChartLabel]="'studies.competitive.intelligence.amount'"
    [teamValueLabelKey]="'studies.competitive.intelligence.amount'"
    [comparisonStudy]="study"
></kiwi-competitive-intelligence>
